var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatistics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3a1 1 0 011 1v16h16a1 1 0 110 2H3a1 1 0 01-1-1V4a1 1 0 011-1zm16.92 3.394a1 1 0 10-1.84-.788l-2.615 6.103-4.094-1.637a1 1 0 00-1.203.373l-4 6a1 1 0 001.664 1.11l3.55-5.325 4.247 1.698a1 1 0 001.29-.534l3-7z"
  })));
}
export default __webpack_public_path__ + "32ea0a04f48718846bea53474075999d.svg";
export { SvgStatistics as ReactComponent };